import React from 'react';
import PropTypes from 'prop-types';
import { Grid } from 'semantic-ui-react';
import CardNavigationItem from './components/CardNavigationItem';
import './mobile.css';

export default class CardNavigation extends React.Component {
  getStackedMobileOrder() {
    const { items } = this.props;
    if (this.itemsAreAlternatingImages()) {
      const others = [];
      const images = [];
      items.forEach(item => {
        if (item.type === 'image') {
          images.push(item);
        } else {
          others.push(item);
        }
      });
      const mobileItems = [];
      let i = 0;
      while (i < others.length) {
        mobileItems.push(others[i]);
        mobileItems.push(images[i]);
        i += 1;
      }
      return mobileItems;
    }
    return items;
  }

  itemsAreAlternatingImages() {
    const { items, itemsPerRow } = this.props;
    if (itemsPerRow === 2 && items.length % 2 === 0) {
      let headerFirst = true;
      if (items[0].type === 'image') {
        headerFirst = false;
      }
      // eslint-disable-next-line consistent-return
      items.forEach((item, index) => {
        if (item.type === 'image') {
          const mod = headerFirst ? 1 : 0;
          if (index % 2 !== mod) {
            return false;
          }
        }
      });
      return true;
    }
    return false;
  }

  render() {
    const { height, itemsPerRow, items, gutter, rounded } = this.props;
    const mobileItems = this.getStackedMobileOrder();

    return (
      <div>
        <div className="desktop-nav">
          <Grid verticalAlign="middle" columns={itemsPerRow}>
            {items.map(({ background, content, link, type }) => (
              <CardNavigationItem
                {...link}
                height={height}
                background={background}
                content={content}
                type={type}
                gutter={gutter || rounded}
                rounded={gutter || rounded}
              />
            ))}
          </Grid>
        </div>
        <div className="mobile-nav">
          <Grid verticalAlign="middle" columns={1}>
            {mobileItems.map(({ background, content, link, type }) => (
              <CardNavigationItem
                {...link}
                height={height}
                background={background}
                content={content}
                type={type}
                gutter={gutter || rounded}
                rounded={gutter || rounded}
              />
            ))}
          </Grid>
        </div>
      </div>
    );
  }
}

CardNavigation.propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      background: PropTypes.string,
      backgroundType: PropTypes.oneOf(['image', 'color']),
      content: PropTypes.element,
      link: PropTypes.shape({
        slug: PropTypes.string.isRequired,
        internal: PropTypes.bool.isRequired,
      }).isRequired,
    }),
  ).isRequired,
  gutter: PropTypes.bool,
  rounded: PropTypes.bool,
  height: PropTypes.number,
  itemsPerRow: PropTypes.number,
  gatsbyLink: PropTypes.element,
};

CardNavigation.defaultProps = {
  gutter: false,
  rounded: false,
  height: 300,
  itemsPerRow: 2,
  gatsbyLink: null,
};
